import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Colors,
  docTypes,
  PermissionsList,
  RolePermission,
  useGlobalStyles,
  useGlobalText,
} from 'utils';
import { AddModalButton, Circle, CreateChancel, DocumentTable, ErrMessage, Line } from 'components';
import { createLoadStyle } from './styles';
import {
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
  httpRequestsOnLoadActions,
  loadActions,
  LoadServices,
} from 'store';
import { CANCELLED, COMPLETED, IN_TRANSIT, PROCESSING } from '../../../../pages/accounting/constants';
import { loadStatusEnum, RENDER_LOADS } from '../../../../pages';
import { loadTabs } from '../../../../pages/loads/constants';

const REQUEST_TYPE = 'ADD_LOAD_DOC';
const DELETE_REQUEST_TYPE = 'SET_LOAD_DOC_STATUS';

export const DocumentsSection = ({}) => {
  const { info } = useSelector((state) => ({
    info: state.loads.loadById,
  }));
  const params = useParams();
  const globalStyles = useGlobalStyles();
  const globalText = useGlobalText();
  const classes = createLoadStyle();
  const dispatch = useDispatch();
  const [done, setDone] = useState(info && info.status !== 'INTRANSIT');
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState('');
  const history = useHistory();
  const pushInfo = history?.location?.state;
  const checkProcess = info?.documents?.length && info?.documents.find((i) => i.type === 'POD' && i?.status === 'ACTIVE');
  const checkRate = info?.documents?.length && info?.documents.find((i) => i.type === 'RATECON' && i?.status === 'ACTIVE');

  useEffect(() => {
    if (info?.documents) {
      if (info?.customer && info?.customer?.requireRateCon === false) {
        setDone(false);
      } else {
        if (info?.status !== IN_TRANSIT) {
          let docInfo = info.documents.filter((i) => i.type === 'RATECON' && i?.status === 'ACTIVE');
          if (docInfo.length) {
            setDone(false);
          } else {
            setDone(true);
          }
        }
      }
    }
  }, [info]);

  const handleSubmit = async () => {
    setError('');
    if (info && info.isTonu === true && !info.carrier) {
      dispatch(httpRequestsOnErrorsActions.appendError('NOT_CARRIER'));
    } else {
      setLoading(true);
      try {
        await LoadServices.SubmitLoad(info?.id);
        dispatch(httpRequestsOnSuccessActions.appendSuccess(RENDER_LOADS));
        dispatch(httpRequestsOnSuccessActions.appendSuccess('LOAD_WAS_SUBMITTED'));
        dispatch(loadActions.getLoadById(info?.id, 'noLoad'));
        if(pushInfo?.loadParams?.tabType === loadTabs.LOAD_GROUPS){
          dispatch(loadActions.getGroupLoads(params?.id, 'noLoad'));
        }
        setLoading(false);
      } catch (e) {
        if (e?.data?.message === 'Terms and condition was not found') {
          dispatch(httpRequestsOnErrorsActions.appendError('TERMS_NOT_FOUND'));
        }
        setError(e?.data?.message);
        setLoading(false);
      }
    }
  };

  const handleProcessing = async () => {
    setError('');
    const loadStatus = { loadStatus: 'PROCESSING' };
    setLoader(true);
    try {
      await LoadServices.SetLoadProcessing(info?.id, loadStatus);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(RENDER_LOADS));
      dispatch(loadActions.getLoadById(info?.id, 'noLoad'));
      if(pushInfo?.loadParams?.tabType === loadTabs.LOAD_GROUPS){
        dispatch(loadActions.getGroupLoads(params?.id, 'noLoad'));
      }
      dispatch(httpRequestsOnSuccessActions.appendSuccess('LOAD_STATUS'));
      setLoader(false);
    } catch (e) {
      setLoader(false);
    }
  };

  const handleSetDocStatus = async (doc, type) => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(DELETE_REQUEST_TYPE));
      const sendInfo = {
        ...doc,
        status: type !== 'edit' ? doc.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' : doc.status,
      };
      await LoadServices.SetLoadDocumentStatus(info?.id, doc.id, sendInfo);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(RENDER_LOADS));
      dispatch(loadActions.getLoadById(info?.id, 'noLoad'));
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_REQUEST_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(DELETE_REQUEST_TYPE));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_REQUEST_TYPE));
    }
  };

  const handleUpload = async (loadDoc) => {
    try {
      const currentFile = { ...loadDoc };
      currentFile.file.originalName = currentFile?.name;
      dispatch(httpRequestsOnSuccessActions.removeSuccess(REQUEST_TYPE));
      await LoadServices.UploadLoadDocument(info?.id, currentFile);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(REQUEST_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(RENDER_LOADS));
      dispatch(httpRequestsOnLoadActions.removeLoading(REQUEST_TYPE));
      dispatch(loadActions.getLoadById(info?.id, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(REQUEST_TYPE));
      dispatch(httpRequestsOnSuccessActions.removeSuccess(REQUEST_TYPE));
    }
  };

  const checkProcessingButton =
    info?.status === IN_TRANSIT && info?.status !== CANCELLED && info?.customer?.requirePOD === false ? true :
      info?.isTonu === true && info?.status === IN_TRANSIT && info?.status !== CANCELLED ? true :
        (info?.status === IN_TRANSIT && info?.status !== CANCELLED && checkProcess);

  return (
    <div>
      <div className={classes.titleAndSwitcher}>
        <div className={globalStyles.centerItem}>
          <Circle number={5} back={Colors.ThemeAqua} />
          <p className={globalText.title}>
            <span style={{ color: Colors.ThemeAqua }}>{checkProcess && checkRate ? '' : '*'}</span>
            Documents
          </p>
        </div>
      </div>
      <div className={globalStyles.flexAndFullWidth}>
        <div className={'MuiAccordionDetails-root'}>
          <Line height={'auto'} />
        </div>
        <div className={classes.documentSection}>
          <DocumentTable
            allDocs={info?.documents}
            documentsTypes={docTypes}
            handleChangeStatus={handleSetDocStatus}
            changeStatusAction={DELETE_REQUEST_TYPE}
            addLoadAction={REQUEST_TYPE}
            handleUploadFile={handleUpload}
            allowSwitchStatus
            dontChangeType
          />

          {info?.customer?.requireRateCon === true &&
            info?.status !== IN_TRANSIT && info?.status !== PROCESSING && info?.status !== COMPLETED &&
            done &&
            <ErrMessage type={'Pass'} text={'For Submit Load Please Upload Rate Con file'} />
          }
          {error &&
            <ErrMessage style={{ margin: '25px 0', position: 'relative' }} type={'Pass'} text={error} />
          }
          {
            !done &&
            info?.status !== CANCELLED &&
            info?.status !== IN_TRANSIT &&
            info?.status !== PROCESSING &&
            info?.status !== loadStatusEnum.PENDING_FLOAT &&
            info?.status !== CANCELLED &&
            info?.status !== COMPLETED &&
            <CreateChancel
              disabled={done || loading}
              loader={loading}
              classes={globalStyles.buttonsStyle}
              create={'Submit Load'}
              chancel={'Cancel'}
              onCreate={handleSubmit}
              onClose={() => history.push('/loads')}
            />
          }
          {info?.status !== CANCELLED && checkProcessingButton ?
            RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.SEND_TO_PROCESSING?.code], 'agentView') &&
            <AddModalButton
              disabled={loader}
              loading={loader}
              styles={{ marginTop: '28px', width: '238px' }}
              handleClick={handleProcessing}
              text={'Send to Processing'}
            />
            :
            info?.status === IN_TRANSIT &&
            <ErrMessage
              type={'Pass'}
              text={'To send the load to processing, at least one POD file is required'}
            />
          }
        </div>
      </div>
    </div>
  );
};